export const TAB_SUBMIT             = 'TAB_SUBMIT';
export const SET_FORM_SUBMITTING    = 'FORM_SUBMITTING';
export const GET_MY_TABS            = 'GET_MY_TABS';
export const CLEAR_TAB_RESPONSE     = 'CLEAR_TAB_RESPONSE';
export const GET_TAB                = 'GET_TAB';
export const CLEAR_TAB              = 'CLEAR_TAB';
export const GET_ARTIST_TABS        = 'GET_ARTIST_TABS';
export const CLEAR_ARTIST_TABS      = 'CLEAR_ARTIST_TABS';
export const GET_ARTIST_BY_LETTER   = 'GET_ARTIST_BY_LETTER';
export const CLEAR_ARTIST_BY_LETTER = 'CLEAR_ARTIST_BY_LETTER';

export const tabSubmit = (data) => {
  return {
    type: TAB_SUBMIT,
    url: window.__env.apiUrl + '/tab/submit',
    data
  }
};

export const setFormSubmitting = () => {
  return {
    type: SET_FORM_SUBMITTING
  }
};

export const getMyTabs = () => {
  return {
    type: GET_MY_TABS,
    url: window.__env.apiUrl + '/tab/myTabs'
  }
};

export const clearTabResponse = () => {
  return {
    type: CLEAR_TAB_RESPONSE
  }
};

export const getTab = (id) => {
  return {
    type: GET_TAB,
    url: window.__env.apiUrl + '/tab/get',
    id
  }
};

export const clearTab = () => {
  return {
    type: CLEAR_TAB
  }
};

export const getArtistTabs = (slug) => {
  return {
    type: GET_ARTIST_TABS,
    url: window.__env.apiUrl + '/tab/getByArtist',
    slug
  }
};

export const clearArtistTabs = () => {
  return {
    type: CLEAR_ARTIST_TABS
  }
};


export const getArtistsByLetter = (letter) => {
  return {
    type: GET_ARTIST_BY_LETTER,
    url: window.__env.apiUrl + '/artist/getByLetter',
    letter
  }
};

export const clearArtistsByLetter = () => {
  return {
    type: CLEAR_ARTIST_BY_LETTER
  }
};


// WEBPACK FOOTER //
// ./src/actions/tabActions.js